import { createSlice } from '@reduxjs/toolkit';

import { callerCreator } from '../callerCreator';

const initialState = {
  report: {
    loading: true,
    error: null,
    commercial_report: null,
    loadingVatData: false,
    isVatCalled: false,
  },
  questionnaire: {
    loading: true,
    error: null,
    company: null,
    request_token: null,
    generatingQuotes: false,
    old_request_token: null,
    modify_data: null,
    errorMessage: null,
    company_branches: null,
  },
  update_report: {
    loading: true,
    error: null,
  },
  catastrophe: {
    loading: false,
    error: null,
    commercial_catastrophe: null,
    request_token: null,
    isSubmitting: false,
    old_request_token: null,
  },
  manual_quote: {
    loading: false,
    error: null,
    request_token: null,
    isSubmitting: false,
  },
};

export const commercialReportSlice = createSlice({
  name: 'commercialReport',
  initialState,
  reducers: {
    getCommercialReportPending: (state) => {
      state.report.loadingVatData = true;
      state.report.error = null;
    },
    getCommercialReportRejected: (state, { payload }) => {
      state.report.loadingVatData = false;
      state.report.error = payload;
      state.report.isVatCalled = true;
    },
    getCommercialReportSuccess: (
      state,
      { payload },
    ) => {
      state.report.loadingVatData = false;
      state.report.commercial_report = payload;
      state.report.isVatCalled = true;
    },
    commercialReportReset: (state) => {
      state.report = { ...initialState.report };
    },
    getQuestionarioPending: (state) => {
      state.questionnaire.loading = true;
      state.questionnaire.error = null;
    },
    getQuestionarioRejected: (state, { payload }) => {
      state.questionnaire.loading = false;
      state.questionnaire.error = payload;
    },
    getQuestionarioSuccess: (
      state,
    ) => {
      state.questionnaire.loading = false;
    },
    getCompanyQuestionarioStatusPending: (state) => {
      state.questionnaire.loading = true;
      state.questionnaire.error = null;
    },
    getCompanyQuestionarioStatusRejected: (state, { payload }) => {
      state.questionnaire.loading = false;
      state.questionnaire.error = payload;
    },
    getCompanyQuestionarioStatusSuccess: (state, { payload = null }) => {
      state.questionnaire.loading = false;
      if (payload) {
        state.questionnaire.company = payload;
      }
    },
    getCompanyQuestionarioCommercialRequestTokenSuccess: (state, { payload }) => {
      state.questionnaire.loading = false;
      state.questionnaire.request_token = payload.request_token;
      state.questionnaire.errorMessage = payload.errorMessage;
    },
    setGeneratingQuotes: (state, { payload }) => {
      state.questionnaire.generatingQuotes = payload;
    },
    resetQuestionnaireRequestToken: (state) => {
      state.questionnaire = { ...state.questionnaire, request_token: null };
    },
    updateCommercialReportPending: (state) => {
      state.update_report.loading = true;
      state.update_report.error = null;
    },
    updateCommercialReportRejected: (state, { payload }) => {
      state.update_report.loading = false;
      state.update_report.error = payload;
    },
    updateCommercialReportSuccess: (state) => {
      state.update_report.loading = false;
    },
    setQuestionarioOldRequestToken: (state, { payload }) => {
      state.questionnaire.old_request_token = payload;
    },
    resetQuestionnaireOldRequestToken: (state) => {
      state.questionnaire.old_request_token = null;
    },
    updateQuestionnaireModifyData: (state, { payload }) => {
      state.questionnaire.modify_data = payload;
    },
    resetQuestionnaireModifyData: (state) => {
      state.questionnaire.modify_data = null;
    },
    updateCompanyBranches: (state, { payload }) => {
      state.questionnaire.company_branches = payload;
    },
    resetCompanyBranches: (state) => {
      state.questionnaire.company_branches = null;
    },
    makeQuotationCommercialCatastrophePending: (state) => {
      state.catastrophe.loading = true;
      state.catastrophe.error = null;
      state.catastrophe.isSubmitting = true;
    },
    makeQuotationCommercialCatastropheRejected: (state, { payload }) => {
      state.catastrophe.loading = false;
      state.catastrophe.error = payload;
      state.catastrophe.isSubmitting = false;
    },
    makeQuotationCommercialCatastropheSuccess: (state, { payload }) => {
      state.catastrophe.loading = false;
      state.catastrophe.request_token = payload;
      state.catastrophe.isSubmitting = false;
    },
    setCatastropheOldRequestToken: (state, { payload }) => {
      state.catastrophe.old_request_token = payload;
    },
    resetCatastropheObject: (state) => {
      state.catastrophe = { ...initialState.catastrophe };
    },
    makeManualQuotePending: (state) => {
      state.manual_quote.loading = true;
      state.manual_quote.error = null;
      state.manual_quote.isSubmitting = true;
    },
    makeManualQuoteRejected: (state, { payload }) => {
      state.manual_quote.loading = false;
      state.manual_quote.error = payload;
      state.manual_quote.isSubmitting = false;
    },
    makeManualQuoteSuccess: (state, { payload }) => {
      state.manual_quote.loading = false;
      state.manual_quote.request_token = payload;
      state.manual_quote.isSubmitting = false;
    },
    updateReportVatCalledStatus: (state, { payload }) => {
      state.report.isVatCalled = payload;
    },
  },
});

export default callerCreator(commercialReportSlice.actions);
